<script>
	import Text from '../atoms/text.svelte';
	import Image from '../atoms/Image.svelte';
</script>

<section>
	<div class="img">
		<Image src="/img/presentation.png" alt="photo de présentation" />
	</div>
	<div class="txt">
		<Text txt="Andréa Sorel maquilleuse professionnelle" />
		<Text txt="basée à Paris/IDF, mais également Rouen ainsi que Lyon, véhiculée." />
		<Text
			txt="Cela fait maintenant 7 ans que j'exerce mon métier. Passionnée par l'art et le dessin depuis mon plus jeune âge, je
    retrouve cette voie en travaillant autour des pigments et des textures."
		/>
		<Text
			txt="Je m'occupe également de la coiffure, après avoir passé le CAP Coiffure cette année, je compte me perfectionner en
    coiffure studio et coiffure de mariée afin de maîtriser tous types de coiffures et cheveux."
		/>
	</div>
</section>

<style>
	section {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.img {
		width: 20%;
		margin: 1%;
	}
	.txt {
		text-align: left;
		margin: 1%;
		width: 45%;
		font-size: x-large;
		color: rgb(83, 70, 102);
	}

	@media screen and (max-width: 900px) {
		.txt {
			font-size: 13px;
		}
		.img {
			display: none;
		}
	}
</style>
